import React, {useEffect, useState} from 'react';
import {BrowserRouter, Route, Switch} from "react-router-dom";
import Layout from "layout/Layout";
import Login from "pages/authentication/Login";
import ForgotPassword from "pages/authentication/ForgotPassword";
import Register from 'pages/authentication/Register';
import LoginPassword from "pages/authentication/LoginPassword";

const App = () => {
    // const history = useHistory();
    const [show, setShow] = useState(false);

    useEffect(() => {
        const url = window.location.pathname;
        if (url !== "/login") {
            const urlParams = new URLSearchParams(window.location.search);
            const product = urlParams.get('product');
            const locale = urlParams.get('locale');
            // ///
            const token = localStorage.getItem('token');
            if (!token) {
                window.location = product ? `/login?product=${product}&locale=${locale}` : "/login";
            } else {
                if (url === "/" && product) {
                    window.location = `/redirect-to-service?product=${product}&locale=${locale}`;
                } else {
                    setShow(true);
                }
            }
        } else {
            setShow(true);
        }

    }, []);
    return (
        <>
            {show && (
                <BrowserRouter>
                    <Switch>
                        {/*{*/}
                        {/*	!localStorage.getItem( "token" ) &&*/}
                        {/*	<Redirect exact from='/' to='/login' />*/}
                        {/*}*/}
                        <Route exact path="/forgot-pass" render={() => <ForgotPassword/>}/>
                        <Route path="/login" component={Login}/>
                        <Route path="/register" component={Register}/>
                        <Route path="/login-password" component={LoginPassword}/>
                        <Route path="/" component={Layout}/>
                    </Switch>
                </BrowserRouter>
            )}

        </>
    );
};

export default App;
